module.exports = __webpack_public_path__ + "static/media/existing_patient_font.620b2104.png";